const filterTypes = {
    SET_FILTERS:'SET_FILTERS'
}

export default filterTypes